
import sampleImage from '../images/products/sample_bimbo_product.png';
import sampleProductImage from '../images/products/sample_donut.png';
import sampleRecipeImage from '../images/recipe_01.png'

export const demoProductList = [
    {
        id: 1, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 2, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 3, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 4, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 5, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 6, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    },
    {
        id: 7, name: 'Product Name', details: 'Product Description', photos: [{ location: sampleImage }
        ]
    }
]

export const demoRecipeList = [
    {
        id: 1, name: 'Recipe Name a little longer to see what it looks like long issa okay I guess its looks strange to me still going to see how it looks', details: 'Product Description', photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 2, name: 'Recipe Name', details: 'Product Description', id: 1, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 3, name: 'Recipe Name', details: 'Product Description', id: 2, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 4, name: 'Recipe Name', details: 'Product Description', id: 3, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 5, name: 'Recipe Name', details: 'Product Description', id: 4, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 6, name: 'Recipe Name', details: 'Product Description', id: 5, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        id: 7, name: 'Recipe Name', details: 'Product Description', id: 6, photos: [{ location: sampleRecipeImage }
        ]
    },
    {
        name: 'Recipe Name', details: 'Product Description', id: 7, photos: [{ location: sampleRecipeImage }
        ]
    }
]
